/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-caret-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.875 14.375l-5-4.375 5-4.375z"/>'
  }
})
